import FieldTypeModel      from '@models/map/FieldTypeModel';
import ProjectModel        from '@models/map/ProjectModel';
import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import MapServiceModel     from '@/models/MapServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';

@model.urnResource('field')
@doc.path('/fields/{?id}')
export default class FieldModel extends Blamable(TimestampAble(MapServiceModel)) {
	private declare _tsFilters: {
		'createdAt': string;
		'fieldType': id;
		'exists[reference]': boolean;
		'fieldType.reference': Map_FieldTypeReference;
		'project': id;
		'project.owner.accountUrn': Urn;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'reference': string;
		'updatedAt': string;
	};

	@doc.model(FieldTypeModel) declare fieldType: FieldTypeModel;
	@doc.string declare label: string;
	@doc.model(ProjectModel) declare project: ProjectModel;
	@doc.string declare reference: Map_FieldReference;

	public renderName(props?: RenderNameProps<this> & FieldModelNameProps) {
		return super.renderName(props);
	}
}